import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=601e973a&scoped=true&"
import script from "./QuizList.vue?vue&type=script&lang=js&"
export * from "./QuizList.vue?vue&type=script&lang=js&"
import style0 from "./QuizList.vue?vue&type=style&index=0&id=601e973a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e973a",
  null
  
)

export default component.exports